"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const botones_1 = require("../../botones");
const fields_1 = require("../../fields/fields");
const React = require("react");
const text_1 = require("../simpleGrid/text");
class FiltroInvalidoComp extends React.PureComponent {
    render() {
        const props = this.props;
        const titulo = props.titulo;
        const label = React.createElement("span", null,
            React.createElement(botones_1.Link, { iconClass: "fa fa-times", onClick: props.onQuitar }),
            " ",
            React.createElement("label", null, titulo),
            " ",
            React.createElement("label", { style: { color: "red" } }, "Filtro inv\u00E1lido"),
            " ");
        const value = (async () => {
            const items = await this.props.items;
            const first = items && items[0];
            return text_1.cellToText(first);
        })();
        return (React.createElement("div", null,
            React.createElement(fields_1.Text, { label: label, value: value, readonly: true })));
    }
}
exports.FiltroInvalidoComp = FiltroInvalidoComp;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/filtroInvalido.js
// module id = 2220
// module chunks = 0